// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3ti9F","addWidgetButton":"Header_addWidgetButton__1OWnl","dashboardTabs":"Header_dashboardTabs__FmpK-","active":"Header_active__21Xjo"};